"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmissionList = void 0;
const constants_1 = require("./constants");
class SubmissionList {
    constructor(lastKey, hasNext, submissions) {
        this.lastKey = lastKey;
        this.hasNext = hasNext;
        this.submissions = submissions;
        if (submissions) {
            this.submissions.forEach((submission) => {
                submission.absoluteUrl = `${constants_1.Constants.ENDPOINT}${submission.url}`;
            });
        }
    }
}
exports.SubmissionList = SubmissionList;
